import { api } from '@/lib/api'

export interface SupportCompany {
  id: number
  name: string
}

export async function getSupportCompanies(params: {
  limit?: number
  offset?: number
  search?: string
}) {
  const query = new URLSearchParams()
  for (const [name, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') {
      query.set(name, String(value))
    }
  }
  const { data, pagination } = await api.getPaginated<SupportCompany>(
    `/admin/feature-flags/companies?${query}`,
  )
  return { items: data, pagination }
}
